import CompareDocuments from "./CompareDocuments";

export default CompareDocuments;
